import Accordion from './components/layout/Accordion';
import AnimateWhenVisible from './components/layout/AnimateWhenVisible';
import Carousel from "./components/layout/Carousel";
import CarouselSelector from "./components/layout/CarouselSelector";
import CollapsibleActivator from "./components/layout/CollapsibleActivator";
import CollapsibleFAQ from "./components/layout/CollapsibleFAQ";
import DeferredBlock from "./components/layout/DeferredBlock";
import MobileScroller from "./components/layout/MobileScroller";
import PackSelector from "./components/layout/PackSelector";
import Parallax from "./components/layout/Parallax";
import Slideshow from "./components/layout/Slideshow";
import Sticky from "./components/layout/Sticky";
import SubNavigation from "./components/layout/SubNavigation";
import SyncHeight from "./components/layout/SyncHeight";
import Tabs from "./components/layout/Tabs";
import TabContents from "./components/layout/TabContents";
import ImageTabs from "./components/layout/ImageTabs";
import CountdownTimer from "./components/content/CountdownTimer";
import Lightbox from "./components/content/Lightbox";

// Duviri color effect - Retire when Duviri hubsite is retired
import Duviri from "./components/content/Duviri";
import {before} from "lodash";

// NodeList.forEach polyfill
if (typeof window !== 'undefined' && window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i ++) {
            callback.call(thisArg, this[i], i, this);
        }
    }
}

const DATA_COMPONENT = "component"
const DATA_INITIALIZED = "initialized"
const SELECTOR_COMPONENT = "[data-" + DATA_COMPONENT + "]";

const matchMobileOnly = window.matchMedia("(max-width: 767px)");
const matchTabletOnly = window.matchMedia("(min-width: 768px) and (max-width: 1279)");
const matchTabletUp = window.matchMedia("(min-width: 768px)");
const matchDesktopOnly = window.matchMedia("(min-width: 1280px) and (max-width: 1919px)");
const matchDesktopUp = window.matchMedia("(min-width: 1280px)");
const matchWideUp = window.matchMedia("(min-width: 1920px)");

const componentTypes = {};
const beforeLoadCallbacks = [];
const afterLoadCallbacks = [];
let isLoaded = false;

export function registerComponent(type) {
    if (!type) {
        console.error(`Error: Attempted to register null or empty component type.`)
        return;
    }
    if (!type.name) {
        console.error(`Error: Attempted to register unnamed component type.`, type);
        return;
    }
    if (!type.initialize) {
        console.error(`Error: Attempted to register component type with no initializer.`, type);
        return;
    }

    componentTypes[type.name] = type;
    //console.log('name: ' + type.name);
}
function initializeComponents(context=null) {
    if (!context || !context.querySelector) context = document;

    const componentElements = context.querySelectorAll(SELECTOR_COMPONENT);
    componentElements.forEach(initializeComponent);
}
function initializeComponent(element) {
    const name = element.dataset[DATA_COMPONENT];
    const type = componentTypes[name];
    if (!name || !type) {
        console.error(`Error: Unrecognized component type specified "${name}"`, element);
        return;
    }

    if (type.alwaysInitialize || !element.dataset[DATA_INITIALIZED]) {
        type.initialize(element, PageComponents);
        element.dataset[DATA_INITIALIZED] = 'true';
    }
}

function finalizeComponents() {
    for (const key in componentTypes) {
        const type = componentTypes[key];
        if (type.finalize) type.finalize(PageComponents);
    }
}

export function isMobileOnly() {
    return matchMobileOnly.matches;
}
export function isTabletOnly() {
    return matchTabletOnly.matches;
}
export function isTabletUp() {
    return matchTabletUp.matches;
}
export function isDesktopOnly() {
    return matchDesktopOnly.matches;
}
export function isDesktopUp() {
    return matchDesktopUp.matches;
}
export function isWideUp() {
    return matchWideUp.matches;
}

export function beforeLoad(callback) {
    if (isLoaded) {
        console.error(`Error: ${callback.name || '(anonymous)'} sent to beforeLoad after PageComponents has already initialized. This will never get run.`)
    }
    beforeLoadCallbacks.push(callback);
}
export function afterLoad(callback) {
    if (isLoaded) {
        callback(PageComponents);
    } else {
        afterLoadCallbacks.push(callback);
    }
}

function initialize() {
    window.addEventListener('load', () => {

        // Pre-initialization callbacks
        beforeLoadCallbacks.forEach((callback) => {
            callback(PageComponents);
        });

        const beforeLoadEvent = new CustomEvent(
            "PageComponentsPreLoad",
            { PageComponents }
        );
        window.dispatchEvent(beforeLoadEvent);

        // Initialize standalone components
        initializeComponents();

        // Initialize components with global behavior
        DeferredBlock.init(PageComponents);
        Sticky.init(PageComponents);

        // Run any finalization methods on components
        finalizeComponents();

        // Post-initialization callbacks
        afterLoadCallbacks.forEach((callback) => {
            callback(PageComponents);
        });

        const afterLoadEvent = new CustomEvent(
            "PageComponentsLoaded",
            { PageComponents }
        );
        window.dispatchEvent(afterLoadEvent);

        isLoaded = true;

    });
}

let PageComponents = window.PageComponents = {
    componentTypes,
    registerComponent,
    beforeLoad,
    afterLoad,
    isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
    isAndroid: /Android/.test(navigator.userAgent),
    isMobileOnly,
    isTabletOnly,
    isTabletUp,
    isDesktopOnly,
    isDesktopUp,
    isWideUp,
    initialize,
};

registerComponent(SyncHeight);
registerComponent(PackSelector);
registerComponent(Parallax);
registerComponent(Carousel);
registerComponent(CarouselSelector);
registerComponent(MobileScroller);
registerComponent(SubNavigation);
registerComponent(Slideshow);
registerComponent(CollapsibleActivator);
registerComponent(CollapsibleFAQ);
registerComponent(AnimateWhenVisible);
registerComponent(Tabs);
registerComponent(TabContents);
registerComponent(ImageTabs);
registerComponent(Accordion);
registerComponent(CountdownTimer);
registerComponent(Lightbox);
registerComponent(Duviri);

export default PageComponents;
